import React from "react";
import styled from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";

const Input = ({
  value,
  onChange,
  placeholder,
  error,
  className,
  size = "sm",
  id,
  ...rest
}) => {
  const clearInput = () => {
    onChange({ target: { value: "" } });
  };

  return (
    <InputWrapper size={size} error={error} className={className} id={id}>
      <InputBox
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        size={size}
        {...rest}
      />
      <CancelIconStyled
        onClick={clearInput}
        size={size}
        fontSize={size === "sm" ? "13px" : "medium"}
      />
    </InputWrapper>
  );
};

export default Input;

export const InputBox = styled.input`
  width: 100%;
  background: transparent;
  font-size: ${({ size }) => (size === "sm" ? "14px" : "18px")} !important;
  font-weight: 400;
  outline: none;
  width: 100%;
  border: none;
`;

export const InputWrapper = styled.div`
  padding: ${({ size }) => (size === "sm" ? "12px" : "20px")};
  border-radius: ${({ size }) => (size === "sm" ? "12px" : "16px")};
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: ${({ size }) => (size === "sm" ? "6px" : "110px")};
  width: ${({ size }) => (size === "sm" ? "100%" : "480px")};
  outline: ${({ error }) => (error ? "1px solid #c54600" : "none")};

  &:focus-within {
    outline: ${({ error }) =>
      error ? "1px solid #c54600" : "1px solid #000000"};
  }
`;

export const CancelIconStyled = styled(CancelIcon)`
  color: #000000;
  cursor: pointer;
  width: ${({ size }) => (size === "sm" ? "12px" : "20px")};
`;
